module.exports = __webpack_public_path__ + "img/选段提问.e671c31d.gif";